let $ = window.jQuery;

$(function() {
  if ($('.slider__slides li').length > 1) {
    let current_slide = 0;
    let num_slides =  $('.slider__slides li').length;
    let animating = false;
    let paused = false;
    let auto_advance_interval = 8000;

    function changeSlide(slide) {

      if (animating === false) {
        animating = true;
        current_slide = slide;

        if (current_slide >= num_slides) {
          $('.slider__slides li').first().css({left: num_slides * 100 + '%'});

          $('.slider__slides').animate({
            left: current_slide * -100 + '%',
          },
          500,
          function() {
            $('.slider__slides').css({left: 0});
            $('.slider__slides li').first().css({left: 0});
            animating = false;
          });

          current_slide = 0;
        } else if (current_slide < 0) {
          $('.slider__slides li').last().css({left: -100 + '%'});
          $('.slider__slides').animate({
            left: 100 + '%',
          },
          500,
          function() {
            $('.slider__slides').css({left: (num_slides - 1) * -100 + '%'});
            $('.slider__slides li').last().css({left: (num_slides - 1) * 100 + '%'});
            animating = false;
          });

          current_slide = num_slides - 1;
        } else {
          $('.slider__slides').animate({
            left: current_slide * -100 + '%',
          },
          500,
          function() {
            animating = false;
          });
        }

        $('.slider__dots li').removeClass('active');
        $('.slider__dots li').eq(current_slide).addClass('active');
      }
    }

    function autoAdvanceSlide() {
      if (!paused !== false) {
        changeSlide(current_slide + 1);
        setTimeout(autoAdvanceSlide, auto_advance_interval);
      }
    }

    $(document).on('click', '.slider__next', function() {
      changeSlide(current_slide + 1);
      paused = true;
    });

    $(document).on('click', '.slider__prev', function() {
      changeSlide(current_slide - 1);
      paused = true;
    });

    $(document).on('click', '.slider__dots li', function() {
      changeSlide($(this).index());
      paused = true;
    });

    $(document).on('keyup', function(e) {
      if(e.keyCode === 37) { // left
        changeSlide(current_slide - 1);
      }
      else if(e.keyCode === 39) { // right
        changeSlide(current_slide + 1);
      }
    });

    setTimeout(autoAdvanceSlide, auto_advance_interval);
  }
});
